// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1373":"4fbac667","7350":"36d9e990","9088":"a4b6ff29"}[chunkId] + ".chunk.css";
};